module.exports = {
	"fr": {
		"static-pages": {
			"notFound": {
				"pageTitle": "Page introuvable",
				"title": "Introuvable",
				"details": "L'application que vous cherchez est introuvable. Êtes-vous sûr d'avoir saisi la bonne adresse ?",
				"goBack": "Revenir"
			},
			"activation": {
				"pageTitle": "Zone de sécurité",
				"title": "Bienvenue dans la zone de sécurité",
				"activate": {
					"details": "Patientez quelques instants, nous préparons votre lien d'activation...",
					"ready": "Votre lien est prêt, cliquez sur le bouton pour continuer. Remarque : ce lien ne peut être utilisé qu'une fois !",
					"go": "Activer le compte"
				},
				"passwordReset": {
					"details": "Patientez quelques instants, nous préparons votre lien de réinitialisation du mot de passe...",
					"ready": "Votre lien est prêt, cliquez sur le bouton pour continuer. Remarque : ce lien ne peut être utilisé qu'une fois !",
					"go": "Réinitialiser le mot de passe"
				},
				"error": {
					"details": "Une erreur s'est produite avec votre lien. Veuillez réessayer, ou contactez l'assistance en indiquant le code."
				}
			},
			"privacy-policy": {
				"pageTitle": "Politique de confidentialité du Portail des marchands"
			},
			"terms-and-conditions": {
				"pageTitle": "Accord du Portail des marchands"
			},
			"Support": {
				"pageTitle": "Assistance",
				"topic": {
					"orders": "Commandes",
					"settlements": "Règlements",
					"agreements": "Accords",
					"technical_issues": "Problèmes techniques",
					"others": "Autres"
				},
				"TicketList": {
					"title": "Demandes d’assistance",
					"pageDescription": "Vous pouvez afficher ici le statut de vos demandes d'assistance",
					"status": {
						"open": "Ouvrir",
						"pending": "En attente",
						"resolved": "Résolu",
						"closed": "Terminé",
						"inProgress": "En cours",
						"waitingForYourReply": "En attente de votre réponse"
					},
					"TicketTable": {
						"id": "Demande n°",
						"mid": "Boutique/MID",
						"subject": "Sujet",
						"status": "Statut",
						"updatedAt": "Dernière mise à jour"
					}
				},
				"EmptyTicketList": {
					"title": "Vous n'avez aucune demande ouverte"
				},
				"ticketDetails": {
					"sidebar": {
						"user": {
							"title": "Utilisateur"
						},
						"details": {
							"title": "Détails",
							"store": "Boutique/MID",
							"createdAt": "Date de la demande",
							"updatedAt": "Dernière mise à jour"
						},
						"actions": {
							"close": "Fermer la demande",
							"reopen": "Rouvrir la demande"
						},
						"closeTicketDialog": {
							"confirm": "Confirmer",
							"title": "Fermer la demande",
							"description": "Vous êtes sur le point de fermer cette demande. Elle pourra être rouverte après une attente de 7 jours.",
							"error": "Oups, une erreur s'est produite ! Veuillez réessayer."
						},
						"reopenTicketDialog": {
							"title": "Rouvrir la demande",
							"description": "Dites-nous pourquoi vous souhaitez rouvrir cette demande et nous vous recontacterons dès que possible.",
							"messageLabel": "Message"
						}
					},
					"conversation": {
						"loadMore": "Charger plus",
						"title": "Demande",
						"attachments": {
							"label": "Pièces jointes"
						},
						"reply": {
							"title": "Ajouter une réponse",
							"body": {
								"label": "Ajouter une réponse",
								"error": null
							},
							"attachment": {
								"label": "Ajoutes des pièces jointes",
								"error": "La taille de tous les fichiers ne doit pas dépasser 15 Mb"
							},
							"add": "Ajouter une réponse",
							"cancel": "Annuler",
							"submit": {
								"label": "Envoyer",
								"error": "Une erreur s'est produite de l'enregistrement de la réponse. Veuillez réessayer plus tard."
							}
						}
					}
				},
				"errorView": {
					"429": {
						"title": "Oups !",
						"message": "Une erreur s'est produite, réessayez dans quelques minutes. Si le problème persiste, contactez-nous pour obtenir de l'aide.",
						"contact": "Lorsque vous contactez l'assistance, veuillez fournir l'ID de corrélation suivant",
						"action": "Contactez-nous"
					},
					"error": "Erreur",
					"default": {
						"title": "Oups, quelque chose ne s’est pas passé comme prévu",
						"message": "Nous n’avons pas pu exécuter votre demande pour une raison que nous ignorons. Vous pouvez réessayer ou revenir plus tard.",
						"contact": "Lorsque vous contactez l'assistance, veuillez fournir l'ID de corrélation suivant",
						"action": "Rafraîchir"
					}
				}
			},
			"Marketing": {
				"pageTitle": "Grab and Go Marketing",
				"banner": {
					"title": "Bienvenue sur Grab and Go Marketing !",
					"subtitle": "C'est ici que vous trouverez des ressources prêtes à l'emploi pour votre site web, vos campagnes e-mail et le marketing sur les réseaux sociaux.",
					"button": "En savoir plus"
				},
				"productSection": {
					"title": "Quel produit Klarna proposez-vous à vos clients ?"
				},
				"MarketSelector": {
					"label": "Sélectionner le marché",
					"markets": {
						"BE": "Belgique (Néerlandais)",
						"BE-FR": "Belgique (Français)"
					}
				},
				"ChannelSelector": {
					"pageTitle": {
						"kco": "Klarna Checkout",
						"fourInstallments": "4 versements",
						"pin30": "Payer dans 30 jours"
					}
				},
				"sourceAndPreview": {
					"helpButton": "Vous avez besoin d'aide ?",
					"copyButton": "Copier vers le presse-papiers",
					"copyButtonSuccess": "Copié !",
					"sourceButton": "Source",
					"previewButton": "Aperçu"
				},
				"EmailTemplates": {
					"pageTitle": "Modèles d'e-mail",
					"title": "Modèles d'e-mail"
				},
				"EmailHeader": {
					"pageTitle": "Image de marketing par e-mail",
					"title": "Image de marketing par e-mail"
				},
				"Social": {
					"pageTitle": "Réseaux sociaux",
					"title": "Réseaux sociaux"
				},
				"buttonDownload": "Télécharger l'image",
				"buttonCopy": "Copier le texte",
				"buttonCopySuccess": "Copié !",
				"missingPreview": "Aperçu non disponible",
				"productLinkText": "Obtenir ces ressources",
				"content": {
					"products": {
						"kco": {
							"title": "Klarna Checkout",
							"subtitle": "Une solution de paiement complète, avec tout ce dont vous avez besoin au même endroit."
						},
						"payNow": {
							"title": "Payer maintenant",
							"subtitle": "Offrez à vos clients la possibilité de payer directement."
						},
						"threeInstallments": {
							"title": "3 versements",
							"subtitle": "Donnez à vos clients la liberté d'étaler leurs dépenses dans le temps sans payer d'intérêts."
						},
						"fourInstallments": {
							"title": "4 versements",
							"subtitle": "Donnez à vos clients la liberté d'étaler leurs dépenses dans le temps sans payer d'intérêts."
						},
						"pin14": {
							"title": "Payer dans 14 jours",
							"subtitle": "Payer sous 14 jours. Pas d'intérêts ni frais supplémentaires."
						},
						"pin21": {
							"title": "Payer dans 21 jours",
							"subtitle": "Payer sous 21 jours. Pas d'intérêts ni frais supplémentaires."
						},
						"pin30": {
							"title": "Payer dans 30 jours",
							"subtitle": "Payer sous 30 jours. Pas d'intérêts ni frais supplémentaires."
						},
						"financing": {
							"title": "Financement",
							"subtitle": "Augmentez vos ventes en proposant à vos clients jusqu'à 36 mois pour payer."
						}
					},
					"campaigns": {
						"holidays-2020": {
							"title": "Vacances 2020",
							"channels": {
								"emailHeader": {
									"title": "Image de marketing par e-mail",
									"subtitle": "Faites revenir vos abonnés sur votre page lors de cette saison des fêtes avec des images de qualité studio pour vos campagnes e-mail.",
									"linkText": "Afficher les images",
									"introduction": "Il est temps de faire découvrir à vos abonnés toutes vos incroyables offres et réductions lors de cette saison des fêtes. Téléchargez une image et ajoutez-la à votre campagne e-mail ou à l'en-tête de votre modèle d'e-mail pour toucher le plus de monde possible."
								},
								"social": {
									"title": "Réseaux sociaux",
									"subtitle": "Attirez plus de clients sur votre boutique lors de la saison des fêtes avec ces images libres d'utilisation.",
									"linkText": "Afficher les posts",
									"introduction": "Il est temps d'annoncer au monde vos incroyables offres et réductions pour cette saison des fêtes ! Téléchargez simplement les ressources et mettez-les en ligne sur vos profils de réseaux sociaux ou vos outils de planification. Souvenez-vous de taguer {link} dans vos annonces pour atteindre un plus grand nombre de clients et de conversions."
								}
							},
							"imageAlt": {
								"holiday1": "Personne en combinaison bleue, rose et argent glisse sur un genou vers un balai ; un bras tient une chaussure argentée et l'autre un smartphone.",
								"holiday2": "Personne en pyjama en satin bordeaux assis en tailleur, lévitant au-dessus d'un ventilateur de bureau avec un smartphone flottant au niveau des yeux."
							}
						},
						"at-launch": {
							"title": "Au moment du lancement",
							"subtitle": "Vous venez d'entamer votre aventure avec nous ? Utilisez ces ressources pour annoncer aux anciens et nouveaux clients que Klarna est maintenant disponible sur votre boutique.",
							"channels": {
								"email": {
									"title": "Modèles d'e-mail",
									"subtitle": "Faites savoir à vos abonnés qu'un nouveau mode de paiement est disponible.",
									"linkText": "Afficher les modèles",
									"introduction": "Il est temps d'annoncer à vos abonnés que Klarna est maintenant disponible sur votre boutique ! Copiez-collez simplement ce modèle ou contenu sur votre plateforme e-mail et c'est parti.",
									"codeBoxTitle": "E-mail de lancement"
								},
								"social": {
									"title": "Réseaux sociaux",
									"subtitle": "Attirez plus de clients sur votre boutique avec ces photos smoooth de qualité studio.",
									"linkText": "Afficher les posts",
									"introduction": "Il est temps d'annoncer au monde que Klarna est maintenant disponible sur votre boutique ! Téléchargez simplement les ressources et mettez-les en ligne sur vos profils de réseaux sociaux ou vos outils de planification. Souvenez-vous de taguer {link} dans vos annonces pour atteindre un plus grand nombre de clients et de conversions."
								},
								"osm": {
									"title": "Pages de lancement",
									"subtitle": "Restez accessible et informez vos clients sur la manière de réaliser des achats avec Klarna.",
									"linkText": "Afficher les pages"
								}
							},
							"imageAlt": {
								"emotional": "Personne avec de longs cheveux bouclés dans une combinaison violette jouant sur un flipper en chrome",
								"paymentShowcase": "Main tenant un téléphone montrant le logo Klarna, avec patins à roulettes en arrière-plan",
								"simplified": "Téléphone face cachée sur un flipper en chrome sur la droite, canapé jaune sur la gauche",
								"device": "Téléphone montrant le logo Klarna pendant au bout d'un appareil hors du cadre, pièce rose avec un chandelier en arrière-plan"
							}
						}
					}
				}
			}
		}
	}
};